import NewSubscriptionSection from "@sections/home/NewSubscriptionSection";

export default function GenreSubscriptionSections({ sections = [] }) {
  return (
    <>
      {sections.map((section) => (
        <NewSubscriptionSection items={section.items} key={section.id} title={section.title} />
      ))}
    </>
  );
}
